import axios from 'axios';
import { store } from './atom.service';
import { userAtom } from '../store/atoms';
import apiClient from './axios.service';
import { User } from '../../../shared/types';

axios.defaults.withCredentials = true;

let state: {
    user: User | undefined,
    authenticated: boolean,
} = {
    user: undefined,
    authenticated: false
};

export function login(contPath?: string, authmethod?: string) {
    const curPath = window.location.pathname;
    let path = (contPath ? contPath : curPath);
    if (!path.startsWith('/')) path = '/' + path;
    const url = window.location.href;
    let next = `/auth/login?cont=${encodeURIComponent(url)}`;
    if (authmethod) {
        next += `&method=${authmethod}`;
    }
    window.location.href = next;
}

export function logout() {
    axios.post('/auth/logout').then(() => {
        state = {
            ...state,
            user: undefined,
            authenticated: false
        };
        store.set(userAtom, null);
        // redirect to home page after logout
        window.location.href = '/';
    });
}

export async function getProfile() {
    const { data: userData } = await apiClient.get('/me');
    if (userData.authenticated !== false) {
        state = {
            ...state,
            user: userData.user,
            authenticated: userData.authenticated
        };

    }

    if (!userData.user) {
        if (store.get(userAtom) !== null) {
            store.set(userAtom, null);
        }
    } else {
        store.set(userAtom, userData.user);
    }

    return state.user;
}

export function getUser() {
    return JSON.parse(JSON.stringify(state.user)); // cheap alternative to lodash clonedeep
}

setInterval(() => {
    if (!state.authenticated) {
        getProfile();
    }
}, 1000 * 60 * 5); // 5 minutes
